import { render, staticRenderFns } from "./ModalGroupAccreditationsFeedback.vue?vue&type=template&id=76117d14&scoped=true"
import script from "./ModalGroupAccreditationsFeedback.vue?vue&type=script&lang=js"
export * from "./ModalGroupAccreditationsFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76117d14",
  null
  
)

export default component.exports